/**
 * Fetch judge prompt metadata from the Synkro API.
 * Prompts are fetched live on every grade call — never cached to disk.
 * This module only fetches the version string for display during install.
 */

interface PromptsMetaResponse {
  version: string;
}

export async function fetchJudgePrompts(opts: {
  gatewayUrl: string;
  jwt: string;
  forceRefresh?: boolean;
}): Promise<{
  version: string;
}> {
  const url = `${opts.gatewayUrl.replace(/\/$/, '')}/api/v1/hook/config`;
  const resp = await fetch(url, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${opts.jwt}`,
      'User-Agent': 'synkro-cli/1.0',
    },
    signal: AbortSignal.timeout(5000),
  });

  if (!resp.ok) {
    return { version: 'unknown' };
  }

  const data = await resp.json() as { prompts?: { version?: string } };
  return { version: data.prompts?.version ?? 'unknown' };
}
